export const VIDEO_PROVIDER_JITSI = "jitsi";
export const VIDEO_PROVIDER_ZOOM = "zoom";

export type VideoProvider = typeof VIDEO_PROVIDER_JITSI | typeof VIDEO_PROVIDER_ZOOM;

export const VIDEO_PROVIDERS: VideoProvider[] = [VIDEO_PROVIDER_JITSI, VIDEO_PROVIDER_ZOOM];

// Sessions predating this feature have no videoProvider key at all,
// so anything unrecognised must resolve to Jitsi. Never default to Zoom.
export const resolveVideoProvider = (settings: any): VideoProvider => {
  const provider = settings && settings.videoProvider;

  if (typeof provider !== "string") {
    return VIDEO_PROVIDER_JITSI;
  }

  const normalized = provider.toLowerCase();

  return (VIDEO_PROVIDERS as string[]).indexOf(normalized) === -1
    ? VIDEO_PROVIDER_JITSI
    : (normalized as VideoProvider);
};
